.page {
  padding-top: var(--tuna-spacing-1);
}

/* Phone: the floating record button sits over the page's bottom-right; leave room so nothing ends under it.
 * 56px is the Fab's large size. */
.pageWithFab {
  padding-bottom: calc(56px + var(--tuna-spacing-4));
}

/* Phone: keyboard focus scrolls a control clear of the floating record button instead of leaving it underneath
 * (WCAG 2.4.11, technique C43). The button covers its own 56px plus its offset above the scroller's bottom edge;
 * one more spacing step keeps a gap. */
.scrollerWithFab {
  scroll-padding-bottom: calc(56px + var(--tuna-spacing-2) * 2 + env(safe-area-inset-bottom, 0px));
}

/* Spaces and the aside wrap without breakpoints: side by side while both fit their basis, stacked below. */
.band {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--tuna-spacing-4);
}

.main {
  flex: 999 1 30rem;
  min-width: 0;
}

.aside {
  flex: 1 1 18rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
}

.aside:empty {
  display: none;
}

.dropHint {
  margin: var(--tuna-spacing-4) 0 0;
  color: var(--tuna-content-secondary);
}

/* Bottom-right, above the phone tab bar (56px tall, see AppChrome). */
.fab {
  position: fixed;
  right: var(--tuna-spacing-2);
  bottom: calc(56px + var(--tuna-spacing-2) + env(safe-area-inset-bottom, 0px));
  z-index: var(--tuna-zIndex-fab);
}
